import $ from 'jquery';

// @ts-ignore
window.jQuery = $;
// @ts-ignore
window.$ = $;
